import React, { useContext, useEffect, useState } from "react";
import styles from "./confirm-payment.module.scss";
import { confirmSmartHomePayment } from "../../swr/smartHomes";
import { ConfirmPaymentRequest } from "../../types/samertHomes";
import { getQuery } from "../../utils/generalUtils";
import LoadingContext from "../../contexts/LoadingContext";
import { useHistory } from "react-router";
import ToastContext from "../../contexts/ToastContext";

const ConfirmPaymentSmartHm = () => {
  const history = useHistory();
  const token = localStorage.getItem("token") as string;
  const homeId = getQuery("smartHomeId");
  const amount = getQuery("amount");
  const [paymentStatus, setPaymentStatus] = useState<boolean | undefined>(
    undefined
  );
  const { setLoading } = useContext(LoadingContext);
  const {openError} = useContext(ToastContext)

  const returnStatusText = (status: boolean | undefined) => {
    if (status === true) {
      return "Payment Confirmed";
    } else if (status === false) {
      return "Payment Unverified";
    } else {
      return "Payment Status Pending...";
    }
  };

  const confirmPaymentApi = async (
    request: ConfirmPaymentRequest,
    token: string
  ) => {
    try {
      setLoading(true);
      const { data, error } = await confirmSmartHomePayment(request, token);
      if (data) {
        // data?.Succeeded === true
        //   ? setPaymentStatus(true)
        //   : setPaymentStatus(false);
        setPaymentStatus(true)
        setLoading(false);
      }
      if (error) {
        setPaymentStatus(false);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if(!token?.length){
  //     history.push("/signin")
  //     openError('Please sign in')
  //   }
  // }, [token?.length])

  return (
    <div className={styles["super-container"]}>
      <div className={styles.card}>
        <span className={styles["card-status"]}>
          {returnStatusText(paymentStatus)}
        </span>

        <span className={styles["card-cta"]}>
          {paymentStatus === true
            ? "Payment Confirmed. Thank you for using Homebuddy."
            : "Please click the button below to confirm the status of your transaction for smart homes installation, once you have made payment"}
        </span>

        <div
          className={styles.cta}
          role="button"
          onClick={() =>
            paymentStatus === true
              ? history.push("/")
              : homeId && amount
              ? confirmPaymentApi(
                  { smartHomeId: parseInt(homeId), amount: parseFloat(amount) },
                  token
                )
              : null
          }
        >
          <span className={styles["cta-txt"]}>
            {paymentStatus === true ? "Done" : "Confirm Payment"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPaymentSmartHm;
